import React, { Component } from "react";
import { connect } from "react-redux";
import "./App.css";
import Grid from "@material-ui/core/Grid";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import leftIcon from "../../images/leftPointer.svg";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

class SuggestedDocumentList extends Component {
  componentDidMount() {

     this.goBack = this.goBack.bind(this); // i think you are missing this
}

goBack(){
    this.props.history.goBack();
}

  render() {
    return (
      <div>
        <div
          style={{
            height: "100px",
            backgroundColor: "#6C0E21",
            verticalAlign: "center",
            textAlign: "center",
          }}
        >
          <Grid
            style={{ height: "100px" }}
            container
            direction="column"
            spacing={12}
          >
            <div className="row">
              <div
                style={{
                  float: "left",
                  width: "15%",
                  padding: "10px",
                  textAlign: "left",
                  height: "100px",
                }}
              >
                <Button
                  onClick={() => { this.goBack() }}
                  style={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "16px",
                    height: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <img
                    style={{ width: "13%", marginRight: "10px" }}
                    src={leftIcon}
                  ></img>
                  {this.context.t("Back")}
                </Button>
              </div>
              <div
                style={{
                  float: "left",
                  width: "75%",
                  padding: "10px",
                  height: "100px",
                  textAlign: "middle",
                  marginTop: "33px",
                }}
              >
                <h3
                  style={{
                    color: "white",
                    textAlign: "center",
                    fontWeight: "bolder",
                    wordWrap: "breakWord",
                    whiteSpace: "normal",
                    fontSize: "17px",
                    fontFamily: "Times New Roman Georgia",
                  }}
                >
                  {this.context.t(
                    "Suggested Documents to be submitted (if applicable)"
                  )}
                </h3>
              </div>
            </div>
          </Grid>
        </div>

        <Grid
          container
          direction="row"
          justifyContent="left"
          alignItems="left"
          
          spacing={12}
        >
          <Grid
            item
            // spacing={8}
            md={12}
            lg={12}
            sm={12}
            xs={12}
            // style={{marginTop:'-50px'}}
            style={{ background: "white", width: "100vw", padding:'35px',}}
          >
            <Typography
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                marginBottom: "5px",
                // marginTop: "15px",
              }}
            >
              {this.context.t("Money Lending dispute")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px", marginTop:'4px' }}>
              {this.context.t("-Loan Agreement")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px", marginTop:'4px'  }}>
              {this.context.t("-Payment Record")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px", marginTop:'4px'  }}>
              {this.context.t("-Repayment Record")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px", marginTop:'4px'  }}>
              {this.context.t("-Identity Card")}
            </Typography>
          </Grid>
        </Grid>
        
        <Grid
          container
          direction="row"
          justifyContent="left"
          alignItems="left"
          
          spacing={12}
        >
          <Grid
            item
            // spacing={8}
            md={12}
            lg={12}
            sm={12}
            xs={12}
            style={{  backgroundColor: "#A70028", width: "100vw", padding:'35px',}}
          >
              
            <Typography
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                marginBottom: "5px",
                marginTop: "15px", color:'white',
              }}
            >
              {this.context.t("Estate Agency Dispute")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px",  color:'white', marginTop:'4px' }}>
              {this.context.t("-Property Information Form")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px",  color:'white', marginTop:'4px' }}>
              {this.context.t("-Leasing Information Form")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px",  color:'white', marginTop:'4px' }}>
              {this.context.t("-Estate Agency Agreement")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px",  color:'white', marginTop:'4px' }}>
              {this.context.t("-Payment Record")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px",  color:'white', marginTop:'4px' }}>
              {this.context.t("-Identity Card")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px",  color:'white', marginTop:'4px' }}>
              {this.context.t("-Provisional Sales and Purchase Agreement")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px",  color:'white', marginTop:'4px'}}>
              {this.context.t("-Advertisement")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px", marginBottom:'10px',  color:'white', marginTop:'4px' }}>
              {this.context.t("-Land search")}
            </Typography>
          </Grid>
        </Grid>
        
        <Grid
          container
          direction="row"
          justifyContent="left"
          alignItems="left"
          
          spacing={12}
        >
          <Grid
            item
            // spacing={8}
            md={12}
            lg={12}
            sm={12}
            xs={12}
            style={{ background: "white", width: "100vw", padding:'35px',}}
          >
            <Typography
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                marginBottom: "5px",
                // marginTop: "15px",
              }}
            >
              {this.context.t("Sales of Goods Dispute")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px", marginTop:'4px' }}>
              {this.context.t("-Sales of Goods Agreement")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px", marginTop:'4px' }}>
              {this.context.t("-Terms and Condition")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px", marginTop:'4px' }}>
              {this.context.t("-Delivery Record")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px", marginTop:'4px' }}>
              {this.context.t("-Return Record")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px", marginTop:'4px' }}>
              {this.context.t("-Payment Record")}
            </Typography>

            <Typography style={{ fontSize: "18px", marginLeft: "5px", marginTop:'4px' }}>
              {this.context.t("-Photo of the Good")}
            </Typography>
          </Grid>
        
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    caseId: state.caseInfo.caseId,
    caseData: state.caseInfo.caseData,
    loadingCaseInfo: state.caseInfo.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // getCaseInfo: (caseId, uniqueId) => dispatch(actions.getCaseInfo(caseId, uniqueId)),
  };
};

SuggestedDocumentList.contextTypes = {
  t: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SuggestedDocumentList));
